// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AcronymController from "./acronym_controller"
application.register("acronym", AcronymController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AutocompleteMultiSearchController from "./autocomplete_multi_search_controller"
application.register("autocomplete-multi-search", AutocompleteMultiSearchController)

import AutocompleteSearchController from "./autocomplete_search_controller"
application.register("autocomplete-search", AutocompleteSearchController)

import AvailabilityInputController from "./availability_input_controller"
application.register("availability-input", AvailabilityInputController)

import AvatarTooltipController from "./avatar_tooltip_controller"
application.register("avatar-tooltip", AvatarTooltipController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import DisableSubmitController from "./disable_submit_controller"
application.register("disable-submit", DisableSubmitController)

import DoubleLoadingController from "./double_loading_controller"
application.register("double-loading", DoubleLoadingController)

import DropdownMultiToggleController from "./dropdown_multi_toggle_controller"
application.register("dropdown-multi-toggle", DropdownMultiToggleController)

import DropdownToggleController from "./dropdown_toggle_controller"
application.register("dropdown-toggle", DropdownToggleController)

import EditToggleController from "./edit_toggle_controller"
application.register("edit-toggle", EditToggleController)

import EmailController from "./email_controller"
application.register("email", EmailController)

import EmptyStateController from "./empty_state_controller"
application.register("empty-state", EmptyStateController)

import ExpandController from "./expand_controller"
application.register("expand", ExpandController)

import FileDownloadController from "./file_download_controller"
application.register("file-download", FileDownloadController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import HoverController from "./hover_controller"
application.register("hover", HoverController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import LeagueSearchController from "./league_search_controller"
application.register("league-search", LeagueSearchController)

import LinkTypeController from "./link_type_controller"
application.register("link-type", LinkTypeController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import LongPressController from "./long_press_controller"
application.register("long-press", LongPressController)

import MajorAbsenceController from "./major_absence_controller"
application.register("major-absence", MajorAbsenceController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotificationBadgeController from "./notification_badge_controller"
application.register("notification-badge", NotificationBadgeController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import NotificationsListController from "./notifications_list_controller"
application.register("notifications-list", NotificationsListController)

import OfficialSearchController from "./official_search_controller"
application.register("official-search", OfficialSearchController)

import OfficialTypeController from "./official_type_controller"
application.register("official-type", OfficialTypeController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PreventSubmitController from "./prevent_submit_controller"
application.register("prevent-submit", PreventSubmitController)

import ProfileStatusController from "./profile_status_controller"
application.register("profile-status", ProfileStatusController)

import RangepickerController from "./rangepicker_controller"
application.register("rangepicker", RangepickerController)

import RichEditorController from "./rich_editor_controller"
application.register("rich-editor", RichEditorController)

import TaggableRichEditorController from "./taggable_rich_editor_controller"
application.register("taggable-rich-editor", TaggableRichEditorController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SortController from "./sort_controller"
application.register("sort", SortController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import SplitValueController from "./split_value_controller"
application.register("split-value", SplitValueController)

import TrainingMandatoryController from "./training_mandatory_controller"
application.register("training-mandatory", TrainingMandatoryController)

import TaskStatusInputController from "./task_status_input_controller"
application.register("task-status-input", TaskStatusInputController)

import TeamTypeController from "./team_type_controller"
application.register("team-type", TeamTypeController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import VenueSearchController from "./venue_search_controller"
application.register("venue-search", VenueSearchController)

import PreventEnterController from "./prevent_enter_controller"
application.register("prevent-enter", PreventEnterController)

import MemberSearchController from "./member_search_controller"
application.register("member-search", MemberSearchController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)

import ParentTypeController from "./parent_type_controller"
application.register("parent-type", ParentTypeController)

import ExerciseSearchController from "./exercise_search_controller"
application.register("exercise-search", ExerciseSearchController)

import CustomSelectController from "./custom_select_controller"
application.register("custom-select", CustomSelectController)

import DragDropController from "./drag_drop_controller"
application.register("drag-drop", DragDropController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import Lightbox from '@stimulus-components/lightbox'
application.register('lightbox', Lightbox)

import GiphySearchController from "./giphy_search_controller"
application.register("giphy-search", GiphySearchController)

import DiscussionSearchController from "./discussion_search_controller"
application.register("discussion-search", DiscussionSearchController)

import DiscussionTagsController from "./discussion_tags_controller"
application.register("discussion-tags", DiscussionTagsController)

import MessageImageUpload from "./message_image_upload_controller"
application.register("message-image-upload", MessageImageUpload)

import DiscussionImageUpload from "./discussion_image_upload_controller"
application.register("discussion-image-upload", DiscussionImageUpload)

import CalendarScope from "./calendar_scope_controller"
application.register("calendar-scope", CalendarScope)

import Rooms from './rooms_controller'
application.register('rooms', Rooms)

import Room from './room_controller'
application.register('room', Room)

import RoomMessageMenu from './room_message_menu_controller'
application.register('room-message-menu', RoomMessageMenu)

import RoomSidePanel from './room_side_panel_controller'
application.register('room-side-panel', RoomSidePanel)

import ActiveLeagueSearch from './active_league_search_controller'
application.register('active-league-search', ActiveLeagueSearch)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import SubmitOnChangeController from "./submit_on_change_controller"
application.register("submit-on-change", SubmitOnChangeController)

import WftdaPickController from "./wftda_pick_controller"
application.register("wftda-pick", WftdaPickController)

import WftdaTeamSearchController from "./wftda_team_search_controller"
application.register("wftda-team-search", WftdaTeamSearchController)